export default "__VITE_ASSET__RZeqRCQw__"